import { Box, Divider, List } from '@mui/material';
import { HelpOutline } from '@mui/icons-material';
import { useState } from 'react';
import useEkko from '../Providers/EkkoProvider';
import useNavigation from '../Providers/NavigationProvider';
import { NavHeader } from './Navigation/NavHeader';
import { NavGroup } from './Navigation/NavGroup';
import { NavItem } from './Navigation/NavItem';

export const NavigationDrawer = (): React.JSX.Element => {
  const { sortedMenuList: subMenuStateList } = useNavigation();
  const { config } = useEkko();

  const [isSortingEnabled, setSortingEnabled] = useState(false);

  return (
    <Box
      height={'100vh'}
      boxShadow={7}
      sx={{
        width: 'fit-content',
        flexShrink: 0,
        overflowX: 'hidden',
        whiteSpace: 'nowrap',
        backgroundColor: 'background.paper',
        scrollbarWidth: 'none',
      }}
    >
      <NavHeader isSortingEnabled={isSortingEnabled} onToggleSorting={() => setSortingEnabled(!isSortingEnabled)} />
      <Divider />
      <List sx={{ flex: 1, overflowY: 'auto', overflowX: 'hidden' }}>
        {subMenuStateList.map((state) => (
          <NavGroup
            key={state.subMenu}
            label={state.subMenu}
            subMenu={state.subMenu}
            isExpanded={state.isOpen ?? false}
            isSortingEnabled={isSortingEnabled}
            accessKeys={state.accessKeys}
          />
        ))}
      </List>
      {config.faqUrl !== undefined && (
        <>
          <Divider />
          <NavItem icon={<HelpOutline />} label="FAQ" onClick={() => window.open(config.faqUrl, '_blank')} />
        </>
      )}
    </Box>
  );
};
